import { tw } from "@careinfo/tailwind";
import DateRangePicker from "../Reusable/DateRangeField";

export default function Filter(props: any) {
  const { register, errors, setValue, getValues, clearErrors, watch } = props;
  return (
    <div
      className={tw`px-4 py-2 rounded-md space-y-2 bg-[#fefefe] mb-4`}
      style={{
        boxShadow: "0px 1px 6px 0px #00000040",
      }}
    >
      <div className={tw`grid grid-cols-2 gap-x-4`}>
        <DateRangePicker
          label={"Select Date Range"}
          setValue={setValue}
          name={"created__range"}
          getValues={getValues}
        />
      </div>
    </div>
  );
}
